import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    status: null,
    error: null,
    userProfile: {},
    fullname: null,
    isLoggedIn: false,
    isHomePage: false,
    token: null,
    sentRequest: null
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload
    },
    setFullname(state, payload) {
      state.fullname = payload
    },
    removeUser(state) {
      state.user = null
    },
    setStatus(state, payload) {
      state.status = payload
    },
    setError(state, payload) {
      state.error = payload
    },
    setIsLoggedIn(state, payload) {
      state.isLoggedIn = payload
    },
    setIsHomePage(state, payload) {
      state.isHomePage = payload
    },
    setToken(state, payload) {
      state.token = payload
    },
    setSentRequest(state, payload) {
      state.sentRequest = payload
    }
  },
  actions: {
    signUpAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
          .then(async (res) => {
            // alert('success')
            // response will have user
            // user will have uid will be updated to the state
            commit('setUser', res.user.uid)
            commit('setStatus', 'success')
            commit('setError', null)
            var resClone = Object.assign({}, res)

            var user = res.user

            const token = await user.getIdToken()
            const idTokenResult = await user.getIdTokenResult()
            const hasuraClaim = idTokenResult.claims['https://hasura.io/jwt/claims']
            // console.log('===> ', hasuraClaim, typeof hasuraClaim)
            if (!hasuraClaim && hasuraClaim === undefined) {
              // console.log('No hasura claims', idTokenResult)
              setTimeout(() => {
                const metadataRef = firebase
                  .database()
                  .ref('metadata/' + user.uid + '/refreshTime')
                // console.log('metadataRef:', metadataRef)
                let callback = async (data) => {
                  // console.log(data, data.exists)
                  if (!data.exists) return
                  // Force refresh to pick up the latest custom claims changes.
                  const token = await user.getIdToken(true)
                  // console.log('Token: ', token)
                  commit('setToken', token)
                  resolve(resClone)
                }
                metadataRef.on('value', callback)
              }, 2000)
            } else {
              // console.log('Hasura claims', hasuraClaim)
              commit('setToken', token)
              resolve(resClone)
            }
          })
          .catch((error) => {
            commit('setStatus', 'failure')
            commit('setError', error.message)
            reject(error)
          })
      })
    },

    signInAction({ commit }, payload) {
      return new Promise((resolve, reject) => {
        firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
          .then(async (response) => {
            commit('setUser', response.user.uid)
            commit('setStatus', 'success')
            commit('setError', null)
            var token = await response.user.getIdToken(true)
            commit('setToken', token)
            resolve(response)
            resolve('OK')
          })
          .catch((error) => {
            commit('setStatus', 'failure')
            commit('setError', error.message)
            reject(error)
          })
      })
    },

    signInGoogleAction({ commit }) {
      return new Promise((resolve, reject) => {
        const provider = new firebase.auth.GoogleAuthProvider()
        firebase.auth().signInWithPopup(provider)
          .then(async (res) => {
            commit('setUser', res.user.uid)
            commit('setStatus', 'success')
            commit('setError', null)
            var resClone = Object.assign({}, res)

            var user = res.user

            const token = await user.getIdToken()
            const idTokenResult = await user.getIdTokenResult()
            const hasuraClaim =
              idTokenResult.claims['https://hasura.io/jwt/claims']
            // console.log('===> ', hasuraClaim, typeof hasuraClaim)
            if (!hasuraClaim && hasuraClaim === undefined) {
              // console.log('No hasura claims', idTokenResult)
              setTimeout(() => {
                const metadataRef = firebase
                  .database()
                  .ref('metadata/' + user.uid + '/refreshTime')

                metadataRef.on('value', async (data) => {
                  // console.log(data)
                  if (!data.exists) return
                  // Force refresh to pick up the latest custom claims changes.
                  const token = await user.getIdToken(true)
                  // console.log('Token: ', token)
                  commit('setToken', token)
                  resolve(resClone)
                })
              }, 2000)
            } else {
              // console.log('Hasura claims', hasuraClaim)
              commit('setToken', token)
              resolve(resClone)
            }
          })
          .catch((error) => {
            commit('setStatus', 'failure')
            commit('setError', error.message)
            reject(error)
          })
      })
    },

    signInFacebookAction({ commit }) {
      return new Promise((resolve, reject) => {
        const provider = new firebase.auth.FacebookAuthProvider()
        firebase.auth().signInWithPopup(provider)
          .then(async (response) => {
            commit('setUser', response.user.uid)
            commit('setStatus', 'success')
            commit('setError', null)
            var token = await response.user.getIdToken(true)
            commit('setToken', token)
            resolve(response)
          })
          .catch((error) => {
            commit('setStatus', 'failure')
            commit('setError', error.message)
            reject(error)
          })
      })
    },

    signOutAction({ commit }) {
      firebase.auth().signOut()
        .then((response) => {
          commit('setUser', null)
          commit('setStatus', 'success')
          commit('setError', null)
          commit('setToken', null)
        })
        .catch((error) => {
          commit('setStatus', 'failure')
          commit('setError', error.message)
        })
    }
  },

  getters: {
    status(state) {
      return state.status
    },
    user(state) {
      return state.user
    },
    fullname(state) {
      return state.fullname
    },
    isLoggedIn(state) {
      return state.isLoggedIn
    },
    error(state) {
      return state.error
    },
    isHomePage(state) {
      return state.isHomePage
    },
    token(state) {
      return state.token
    },
    sentRequest(state) {
      return state.sentRequest
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js